import '@vueron/kiska/style.css';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { createRoot } from 'react-dom/client';

import '@sapporo/ui/style/base.css';
import { initI18n } from '@sapporo/core/i18n';
import { initSentry } from '@sapporo/core/util/sentry';
import { takeDelegationSessionFromUrl } from '@sapporo/state/provider/delegation/delegationUrl';

console.log(String.raw`  ____     _     ____   ____    ___   ____    ___
 / ___|   / \   |  _ \ |  _ \  / _ \ |  _ \  / _ \
 \___ \  / _ \  | |_) || |_) || | | || |_) || | | |
  ___) |/ ___ \ |  __/ |  __/ | |_| ||  _ < | |_| |
 |____//_/   \_\|_|    |_|     \___/ |_| \_\ \___/
`);

dayjs.extend(utc);

const entryHref = location.href;
// NOTE: 라우터(`./App` import 시 생성)와 Sentry 가 주소를 읽기 전에 실행해야 합니다
const delegationSession = takeDelegationSessionFromUrl();
// 첫 렌더 전에 청크 로드 실패로 새로고침할 때 위임이 풀리지 않도록 진입 주소를 둡니다
let delegationReloadHref = delegationSession ? entryHref : null;

// 배포로 이전 청크가 사라졌을 때 한 번만 새로고침합니다. 연속 실패는 ErrorPage 가 처리합니다.
window.addEventListener('vite:preloadError', event => {
  const PRELOAD_RELOAD_AT = 'xfactory:preloadReloadAt';
  const lastReloadAt = Number(sessionStorage.getItem(PRELOAD_RELOAD_AT) ?? 0);

  if (Date.now() - lastReloadAt < 1000 * 10) return;

  event.preventDefault();
  sessionStorage.setItem(PRELOAD_RELOAD_AT, `${Date.now()}`);

  // 새로고침은 referrer 를 유지하므로 주소만 되돌리면 다시 위임 진입으로 처리됩니다
  if (delegationReloadHref) {
    history.replaceState(history.state, '', delegationReloadHref);
  }

  window.location.reload();
});

async function enableMocking() {
  const { startMocking } = await import('./mock/browser');
  return startMocking();
}

if (import.meta.env.DEV && import.meta.env.VITE_APP_MSW_ENABLED == 1) {
  enableMocking();
}

initSentry();

// 첫 렌더 전에 현재 언어 번역을 로드해 번역 키가 잠깐 보이지 않게 합니다.
// 위임 초기화·인터셉터 모듈은 store 들을 끌고 오므로 엔트리에 정적으로 넣지 않습니다.
const [
  { default: App },
  { registerMiriInterceptors },
  { initDelegationSession },
] = await Promise.all([
  import('./App'),
  import('@sapporo/state/provider/api/miriInterceptor'),
  import('@sapporo/state/provider/delegation/initDelegationSession'),
  initI18n(),
]);

// NOTE: 첫 Miri 요청보다 먼저 실행해야 하므로 render 전에 둡니다
initDelegationSession(delegationSession);
registerMiriInterceptors();

createRoot(document.getElementById('app')!).render(<App />);

delegationReloadHref = null;
